import { render, staticRenderFns } from "./AllReviewsModal.vue?vue&type=template&id=617eed4d"
import script from "./AllReviewsModal.vue?vue&type=script&lang=js"
export * from "./AllReviewsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports